export const authProviderMessages = {
  signOutError: 'Error signing out. Please try again.',
  initialSessionError: 'Error getting session data. Please try again.',
} as const;
